import { createApi } from "@reduxjs/toolkit/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware"
import { defaultBaseQueryUserDetails, defautBaseQuery } from '../../utils/API/fetchBaseQuery';

const productImportAPI = createApi({
    reducerPath: 'productImportAPI',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({

        getAllProductImport: builder.query({
            query: function (params) {
                const { url } = params;

                let { first, rows, sortField, sortOrder, search, statusId, ...retVal } = params.params;

                retVal.Pagination = {
                    PageNumber: (first / rows) + 1,
                    PageSize: rows
                };
                retVal.filters = { searchText: search };
                retVal.sortString = '';
                //retVal.pageIndex = (first / rows);
                //retVal.pageSize = rows;

                if (sortField) {
                    retVal.sortField = sortField;
                    retVal.sortDesc = sortOrder < 0;
                }
                if (statusId >= 0) {
                    retVal.statusId = statusId
                }

                return {
                    url: params.url,
                    params: { queryRequest: JSON.stringify(retVal) }
                };
            },
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteProductImportByProductImportId: builder.mutation({
            query: (productImportId) => ({
                url: encryptQueryString(`/ProductImport/deleteProductImportByProductImportId/${productImportId}`),
                method: 'DELETE',
                body: transformRequest(productImportId)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        exportChemindexAnalyzer: builder.mutation({
            query: () => ({
                url: '/ProductImport/ExportChemindexAnalyzer',
                method: 'POST',
                responseHandler: (response) => response.blob(),
            }),
            transformErrorResponse: transformErrorResponse
        }),
        getProductImportById: builder.query({
            query: (productImportId) => ({
                url: `/ProductImport/GetProductImportById?productImportId=${productImportId}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getProductDataSyncListByProductId: builder.query({
            query: (productImportId) => ({
                url: `/ProductImport/GetProductDataSyncListByProductId?productImportId=${productImportId}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getProductImportOutputFileById: builder.query({
            query: (productImportId) => ({
                url: `/ProductImport/GetProductImportOutputFileById?productImportId=${productImportId}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addProductImport: builder.mutation({
            query: (data) => ({
                url: '/ProductImport/AddProductImport',
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addProductDataAutoSync: builder.mutation({
            query: (data) => ({
                url: '/ProductImport/AddProductDataAutoSync',
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getSchedulerStatus: builder.query({
            query: () => ({
                url: '/SchedulerStatus',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateProductImportStatusWhenSchedulerStop: builder.mutation({
            query: (errorMessage) => ({
                url: `/ProductImport/UpdateProductImportStatusWhenSchedulerStop?errorMessage=${errorMessage}`,
                method: 'POST',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getRunningProductImportList: builder.query({
            query: () => ({
                url: '/ProductImport/GetRunningProductImportList',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        requeueRunningProductImportList: builder.mutation({
            query: (details) => ({
                url: '/ProductImport/RequeueRunningProductImportList',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    }),
});

export const { useLazyGetAllProductImportQuery, useDeleteProductImportByProductImportIdMutation, useExportChemindexAnalyzerMutation, useLazyGetProductImportByIdQuery, useLazyGetProductDataSyncListByProductIdQuery, useLazyGetProductImportOutputFileByIdQuery, useAddProductImportMutation, useAddProductDataAutoSyncMutation, useGetSchedulerStatusQuery, useLazyGetSchedulerStatusQuery, useUpdateProductImportStatusWhenSchedulerStopMutation, useLazyGetRunningProductImportListQuery, useRequeueRunningProductImportListMutation } = productImportAPI;

export default productImportAPI;